// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"e9b7eca9","218":"7d2fff99","412":"bc4eb966","453":"1c6375f5","650":"9c9dbede"}[chunkId] + ".chunk.js";
};